import { error, finish } from '../../../modules/selections/actions/result';
import { request as refreshEvent } from '../../../modules/events/actions/get';
import api from '../../../api';
import addError from '../../../utils/error.jsx';

export function request(dispatch, { id, eventId, marketId, result } ) {
    api.post(`/events/${eventId}/markets/${marketId}/selections/${id}/result`, result).then(
        selection => {
            dispatch(finish(id));
            dispatch(refreshEvent(eventId));
        },
        errors => {
            console.info('errors ...', {id, errors});
            dispatch(error(id, errors));
        }
    );
}

export function resultBulkSelections( dispatch, { eventId, marketId, selections } ) {
    api.post( `/events/${eventId}/markets/${marketId}/result`, { selections } ).then(
        () => dispatch( refreshEvent( eventId ) ),
        ( { errors } ) => addError(errors)
    );
}
